import z from 'zod';

const PhoneNumberSchema = z.string().max(100).trim();
const OutboundEndpointSchema = z.string().max(100).trim();
const OutboundEncryptionSchema = z.union([
  z.literal('TLS/SRTP' as const),
  z.literal('UDP/RTP' as const),
]);

const inviteCase = z.literal('invite' as const);
const referCase = z.literal('refer' as const);
const byeCase = z.literal('bye' as const);

const sipMethod = z.union([inviteCase, referCase, byeCase]);

export type SipMethod = z.infer<typeof sipMethod>;

const SipConfigSchemaDiscriminated = z.discriminatedUnion('$case', [
  z.object({
    $case: inviteCase,
    value: z.object({
      phoneNumber: PhoneNumberSchema,
      outboundEndpoint: OutboundEndpointSchema,
      outboundEncryption: OutboundEncryptionSchema,
    }),
  }),
  z.object({
    $case: referCase,
    value: z.object({
      phoneNumber: PhoneNumberSchema,
    }),
  }),
  z.object({
    $case: byeCase,
    value: z.object({}),
  }),
]);

export const SipConfigSchema = z.object({
  config: SipConfigSchemaDiscriminated,
});

export type SipConfig = z.infer<typeof SipConfigSchema>;

export const SipHeadersSchema = z.object({
  headers: z.array(z.object({ key: z.string(), value: z.string() })),
});
